import { render, staticRenderFns } from "./CheckInfo.vue?vue&type=template&id=4872cd54&scoped=true&"
import script from "./CheckInfo.vue?vue&type=script&lang=js&"
export * from "./CheckInfo.vue?vue&type=script&lang=js&"
import style0 from "./CheckInfo.vue?vue&type=style&index=0&id=4872cd54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4872cd54",
  null
  
)

export default component.exports